import { Carousel } from '@strata/react-carousel';
import { groupAndSortHomeScreenMessages } from '@strata/react-page-templates';
import { useEffect, useState } from 'react';

import { getCarouselImage } from 'api/announcementAPI';
import { useAppDispatch } from 'store';
import {
    useGetHomeScreenMessagesQuery,
    usePostCarouselViewedMutation,
} from 'store/api/announcementApi';

export const FeatureCarousel = () => {
    const dispatch = useAppDispatch();
    const { data: messages } = useGetHomeScreenMessagesQuery();
    const [postCarouselViewed] = usePostCarouselViewedMutation();

    const { carousels } = groupAndSortHomeScreenMessages(messages);

    // Load images for active carousel
    const activeCarousel = carousels?.[0];
    const [carouselImages, setCarouselImages] = useState<File[]>();
    useEffect(() => {
        void (async () => {
            if (activeCarousel) {
                setCarouselImages(
                    await Promise.all(
                        activeCarousel.images.map((filename: string) =>
                            getCarouselImage({ messageId: activeCarousel.message_id, filename }),
                        ),
                    ),
                );
            }
        })();
    }, [activeCarousel, dispatch]);

    const onCarouselClose = () => {
        void (async () => {
            setCarouselImages(undefined);
            await postCarouselViewed({ messageId: activeCarousel.message_id });
        })();
    };

    return (
        <Carousel
            isOpen={!!(activeCarousel && carouselImages)}
            onClose={onCarouselClose}
            slides={activeCarousel?.message?.map((slide) => ({
                ...slide,
                image: (() => {
                    const imgForSlide = carouselImages?.find(
                        (img) => img.name === slide.image?.[0]?.name,
                    );
                    return imgForSlide && URL.createObjectURL(imgForSlide);
                })(),
            }))}
        />
    );
};
